// import React from "react";

// const Contact = () => {
//   return (
//     <section className="min-h-screen bg-[#0F172A] py-16 flex justify-center items-center">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
//           {/* ===== LEFT INFO PANEL ===== */}
//           <div>
//             <span className="text-sm font-semibold tracking-wide text-[#2DD4BF]">
//               GET IN TOUCH
//             </span>

//             <h1 className="mt-2 text-3xl sm:text-4xl font-bold text-white">
//               We’re Here to Help <br />
//               <span className="text-[#38BDF8]">Let’s Connect</span>
//             </h1>

//             <p className="mt-4 text-gray-400 max-w-md leading-7">
//               Have questions or need assistance? Our team is here to help. Reach
//               out via the contact form, email, or phone, and we’ll respond
//               promptly to assist with your needs.
//             </p>

//             {/* Contact Info */}
//             <div className="mt-8 space-y-5 text-sm text-gray-300">
//               <div>
//                 <p className="font-semibold text-gray-400">Office</p>
//                 <p className="text-[#38BDF8]">
//                   Plot - 138, SahooNibas, Barapur, Basudevpur, Bhadrak, Odisha,
//                   India, 756046
//                 </p>
//               </div>

//               {/* <div>
//                 <p className="font-semibold text-white">Bengaluru Branch</p>
//                 <p>
//                   Smart Avenue, Unit F0-02, 4th Floor, 80 Feet Rd, Indiranagar,
//                   Bengaluru – 560038
//                 </p>
//               </div> */}

//               <div>
//                 <p className="font-semibold text-gray-400">Email Support</p>
//                 <p className="text-[#38BDF8]">info.digitaltranss@gmail.com</p>
//               </div>

//               <div>
//                 <p className="font-semibold text-gray-400">Let’s Talk</p>
//                 <p className="text-[#38BDF8]">+91-83288 66474</p>
//               </div>
//             </div>
//           </div>

//           {/* ===== RIGHT FORM PANEL ===== */}
//           <div className="bg-[#1E293B] rounded-2xl shadow-[0_30px_60px_rgba(0,0,0,0.4)] p-6 sm:p-8">
//             <h2 className="text-xl sm:text-2xl font-semibold text-white">
//               Send us a message
//             </h2>

//             <p className="mt-2 text-sm text-gray-400">
//               Fill out the form below and we’ll get back to you as soon as
//               possible.
//             </p>

//             <form className="mt-6 space-y-4">
//               {/* Name & Company */}
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <input
//                   type="text"
//                   placeholder="Your Name"
//                   className="input-dark"
//                 />
//                 <input
//                   type="text"
//                   placeholder="Company"
//                   className="input-dark"
//                 />
//               </div>

//               {/* Phone & Email */}
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <input type="tel" placeholder="Phone" className="input-dark" />
//                 <input
//                   type="email"
//                   placeholder="Email"
//                   className="input-dark"
//                 />
//               </div>

//               {/* Subject */}
//               <input type="text" placeholder="Subject" className="input-dark" />

//               {/* Message */}
//               <textarea
//                 rows="4"
//                 placeholder="Message"
//                 className="input-dark resize-none"
//               />

//               {/* Button */}
//               <button
//                 type="submit"
//                 className="
//                   mt-2 w-full rounded-lg
//                   bg-[#2DD4BF] py-3
//                   font-semibold text-[#0F172A]
//                   transition hover:bg-[#14B8A6]
//                 "
//               >
//                 Send Message
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;

import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.placeholder.toLowerCase().replace(" ", "")]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          service: formData.subject || "General Inquiry",
          name: formData.name,
          email: formData.email,
          phone: formData.phone || "N/A",
          company: formData.company || "N/A",
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      );

      setSuccess(true);
      setFormData({
        name: "",
        company: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Email Error:", error);
      alert("Failed to send message. Please try again.");
    }

    setIsSubmitting(false);
  };

  return (
    <section className="min-h-screen bg-[#0F172A] py-16 flex justify-center items-center">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pt-20">
          {/* LEFT PANEL */}
          <div>
            <span className="text-sm font-semibold tracking-wide text-[#2DD4BF]">
              GET IN TOUCH
            </span>

            <h1 className="mt-2 text-3xl sm:text-4xl font-bold text-white">
              We’re Here to Help <br />
              <span className="text-[#38BDF8]">Let’s Connect</span>
            </h1>

            <p className="mt-4 text-gray-400 max-w-md leading-7">
              Have questions or need assistance? Our team is here to help. Reach
              out via the contact form, email, or phone, and we’ll respond
              promptly to assist with your needs.
            </p>

            {/* Contact Info */}
            <div className="mt-8 space-y-5 text-sm text-gray-300">
              <div>
                <p className="font-semibold text-gray-400">Office</p>
                <p className="text-[#38BDF8]">
                  Plot - 138, SahooNibas, Barapur, Basudevpur, Bhadrak, Odisha,
                  India, 756046
                </p>
              </div>

              <div>
                <p className="font-semibold text-gray-400">Email Support</p>
                <p className="text-[#38BDF8]">info.digitaltranss@gmail.com</p>
              </div>

              <div>
                <p className="font-semibold text-gray-400">Let’s Talk</p>
                <p className="text-[#38BDF8]">+91-83288 66474</p>
              </div>
            </div>
          </div>

          {/* FORM PANEL */}
          <div className="bg-[#1E293B] rounded-2xl shadow-[0_30px_60px_rgba(0,0,0,0.4)] p-6 sm:p-8">
            <h2 className="text-xl sm:text-2xl font-semibold text-white">
              Send us a message
            </h2>

            {success && (
              <p className="mt-3 text-green-400 text-sm">
                ✅ Message sent successfully!
              </p>
            )}

            <form onSubmit={handleSubmit} className="mt-6 space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="input-dark"
                />
                <input
                  type="text"
                  placeholder="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="input-dark"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="tel"
                  placeholder="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="input-dark"
                />
                <input
                  type="email"
                  placeholder="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="input-dark"
                />
              </div>

              <input
                type="text"
                placeholder="subject"
                value={formData.subject}
                onChange={handleChange}
                className="input-dark"
              />

              <textarea
                rows="4"
                placeholder="message"
                value={formData.message}
                onChange={handleChange}
                required
                className="input-dark resize-none"
              />

              <button
                type="submit"
                disabled={isSubmitting}
                className="
                  mt-2 w-full rounded-lg
                  bg-[#2DD4BF] py-3
                  font-semibold text-[#0F172A]
                  transition hover:bg-[#14B8A6]
                  disabled:opacity-60
                "
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
